"use client";
import { useRef } from "react";
import { Button } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { PageWrapper } from "@onair/ui/layouts/page-wrapper";
import { useRouter } from "next/navigation";
import SurveyForm, { SurveyFormRef } from "../_components/survey-form";
import useCRUDSurvey from "../hooks/use-CRUD-survey";
import DialogSuccess from "../_components/dialog-success";

const PageCreateSurvey = () => {
	const router = useRouter();
	const actionRef = useRef<"create" | "sortCreate">();
	const surveyFormRef = useRef<SurveyFormRef>(null);

	const { isOpen, closeDialog, openDialog } = DialogSuccess.useDialog();
	// const { onCreateSurvey, isLoading, onSoftCreate } = useCRUDSurvey();
	const isLoading = false;
	/**
	 * Create
	 */
	const handleCreateSurvey = () => {
		actionRef.current === "create";
		const handleSubmitForm = surveyFormRef.current?.submit("Create");

		if (!handleSubmitForm) return;

		handleSubmitForm((data) => {
			//  onCreateSurvey(data);
			openDialog();
		})();
	};

	/**
	 * SoftCreate
	 */

	const handlePreviewSurvey = () => {
		actionRef.current === "sortCreate";
		const handleSubmitForm = surveyFormRef.current?.submit("SoftCreate");
		// handleSubmitForm?.((data) => {
		// 	 onSoftCreate(data);
		// })();
	};

	return (
		<PageWrapper
			title="Tạo khảo sát"
			onBack={() => router.push("/")}
			actions={
				<>
					{/* <Button
						variant="outlined"
						color="primary"
						size="large"
						startIcon={<Iconify icon="solar:eye-bold" />}
						onClick={handlePreviewSurvey}
						disabled={isLoading}
					>
						Xem trước
					</Button> */}
					<Button
						variant="contained"
						color="primary"
						size="large"
						onClick={handleCreateSurvey}
						disabled={isLoading}
					>
						{isLoading && actionRef.current === "create"
							? "Loading..."
							: "Tạo ngay"}
					</Button>
				</>
			}
			className="bg-slate-100 my-0 py-6"
		>
			<SurveyForm ref={surveyFormRef} initialValues={undefined} />
			<DialogSuccess isOpen={isOpen} />
		</PageWrapper>
	);
};
export default PageCreateSurvey;
